import { render, staticRenderFns } from "./DataSubjectView.vue?vue&type=template&id=68e7e2e6&"
import script from "./DataSubjectView.vue?vue&type=script&lang=js&"
export * from "./DataSubjectView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports